export const EVENT_DEEP_LINK_KEY = 'deeplink_url';
export const COUPON_DEEP_LINK_BASE_VALUE = 'amondz://coupon/';
export const EVENTAPPLY_DEEP_LINK_BASE_VALUE = 'amondz://eventapply/';
/**
 * 설문 링크 식별 키.
 *
 * 클릭 레이어 url 에 `?amondz_survey={code}` 가 붙어 있으면 설문으로 봅니다.
 * amondz:// 같은 앱 스킴을 쓰지 않는 이유:
 * - PC 웹(apps/user-pc)에는 이 처리가 없습니다. 앱 스킴이면 PC에서 아무 반응이
 *   없지만, 실제 웹 주소를 넣어두면 PC는 그 페이지로 그냥 이동합니다.
 * - 가로채기가 실패하더라도 최악의 경우 해당 페이지가 열립니다. 앱 스킴은 iOS에서
 *   무반응, Android에서 커스텀 탭 실패로 조용히 깨집니다.
 * - 설문이 끝나 이 처리를 지워도 링크는 그대로 동작합니다.
 */
export const SURVEY_LINK_QUERY_KEY = 'amondz_survey';

export const LUCKY_DRAW_MSG = {
  CONFIRM_WITH_MARKETING_PUSH_TITLE: '이벤트 참여 하시겠습니까?',
  CONFIRM_WITH_MARKETING_PUSH_DESCRIPTION: '확인 버튼을 누르시면, 마케팅 푸시 수신에 동의하신 것으로 간주됩니다.',
  SUCCESS: '이벤트 참여가 완료 되었습니다.',
  ENABLE_MARKETING_PUSH_COMPLETE: '마케팅 푸시 수신 동의가 완료되었습니다.',
  ALREADY_DONE: '이미 응모 하셨습니다.',
  NO_LUCKY_DRAW_CODE: '종료된 이벤트 입니다.',
} as const;

export const SURVEY_MSG = {
  TITLE: '갖고 싶은 상품을 제안해 주세요',
  TITLE_EMPHASIS: '갖고 싶은 상품',
  TITLE_SUFFIX: '을 제안해 주세요✨',
  SUGGESTION_PLACEHOLDER: '예) 얇은 실반지를 찾고 있어요. 실버 소재로 겹쳐 끼기 좋은 디자인이면 좋겠어요.',
  PHONE_LABEL: '연락처',
  PHONE_PLACEHOLDER: '010-0000-0000',
  PHONE_HELP: '선정 시 안내드릴 때만 사용됩니다.',
  // 회원정보에 연락처가 없는 경우에만 직접 입력받습니다.
  PHONE_FALLBACK_HELP: '회원정보에 연락처가 없어요. 선정 시 안내받을 번호를 알려주세요.',
  SUBMIT: '응답 제출하기',
  SUBMITTING: '전송 중...',
  CONSENT_LABEL: '개인정보 수집·이용에 동의합니다. (필수)',
  CONSENT_DETAIL_SUMMARY: '자세히 보기',
  CONSENT_ITEMS: [
    '수집 항목: 회원정보에 등록된 연락처 (미등록 시 직접 입력한 연락처)',
    '수집 목적: 제안 확인 및 선정 시 안내',
    '보유 기간: 목적 달성 후 6개월 내 파기',
    '동의를 거부할 수 있으나, 이 경우 제안 접수가 불가합니다.',
  ],
  CONSENT_REQUIRED: '개인정보 수집·이용에 동의해 주세요.',
  CLOSE: '닫기',
  SUCCESS_TITLE: '제안이 전달되었어요',
  SUCCESS_DESCRIPTION: '보내주신 의견은 다음 입고 기획에 참고됩니다.',
  EMPTY_SUGGESTION: '원하시는 상품을 입력해 주세요.',
  INVALID_PHONE: '연락처 형식을 확인해 주세요. (예: 010-1234-5678)',
  FAIL: '전송에 실패했습니다. 다시 시도해 주세요.',
} as const;

export const SURVEY_SUGGESTION_MAX_LENGTH = 300;

// 해당 문자열로 시작되는 럭키드로우 코드는 마케팅 푸시 상태를 ON으로 변경함(마케팅 푸시 알림 고지 필요)
export const APPLY_LUCKY_DRAW_WITH_MARKETING_PUSH_ENABLE_STARTING_CODE = 'P';

export const EVENT_SECTION_INDEX = {
  IMAGE: 0,
  VIDEO: 1,
  ANIMATION: 2,
  SWIPE: 3,
  TEXT: 4,
} as const;
export const IS_INFINITY = {
  TRUE: 1,
  FALSE: 0,
} as const;

export const BANNER_WIDGET_ITEM_LINK_TYPE = {
  WIDGET: 0,
  BRAND: 1,
  EVENT: 2,
  PRODUCT_LIST: 3,
  BRAND_LIST: 4,
  LIKE_PRODUCT: 5,
  LIKE_BRAND: 6,
  CART: 7,
  POINT: 8,
  COUPON: 9,
  ORDER_LIST: 11,
  PRODUCT_REVIEW_WRITE: 12,
  PRODUCT_REVIEW_LIST: 13,
  MEMBER_MANAGE: 14,
  PRODUCT_DETAIL: 16,
  REVIEW_DETAIL: 17,
  EXTERNAL_LINK: 1000,
  CATEGORY_LINK: 1001,
  HOME: 2000,
} as const;
